import PostAcademyCategories from '../Components/Categories/PostAcademyCategories'
import Select, { createFilter } from 'react-select'
import ServiceOptions from '../Components/PhotoOptions/ServiceOptions'
import { filterNewApprovalPhotos, filterNewGalleryPhotos, getObjectFromValue, getValueFromObject } from '../Functions'
import update from 'immutability-helper'
import { TextControl } from '@wordpress/components'
import React from 'react'

const ServiceSearch = ({ setState, state, varNames }) => {
  const {
    [`${varNames.category}`]: category,
    [`${varNames.service}`]: service,
    [`${varNames.year}`]: year
  } = state
  const callbacks = {
    filterNewGalleryPhotos: ({ state, setState, varNames }) => {
      filterNewGalleryPhotos({ state, setState, varNames })
    },
    filterNewApprovalPhotos: ({ state, setState, varNames }) => {
      filterNewApprovalPhotos({ state, setState, varNames })
    }
  }

  return (
    <div className='search-service'>
      {(() => {
        if (PostAcademyCategories.includes(category)) {
          if (category === 'In Uniform') {
            return (
              <Select
                isClearable
                className='photos-search-container'
                options={ServiceOptions}
                placeholder='Select a service...'
                onChange={(service) => {
                  callbacks[`${varNames.callback}`]({
                    state: update(state, {
                      [`${varNames.service}`]: { $set: getValueFromObject(service) || '' },
                      [`${varNames.serviceBranch}`]: { $set: '' }
                    }),
                    setState: (state) => setState(state),
                    varNames
                  })
                }}
                value={getObjectFromValue(service, ServiceOptions)}
                filterOptions={createFilter({ ignoreCase: true, ignoreAccents: true })}
              />
            )
          } else if (category === 'Post Military Life') {
            return (
              <TextControl
                isClearable
                onChange={(year) => {
                  filterNewGalleryPhotos({
                    state: update(state, {
                      [`${varNames.year}`]: { $set: year || '' }
                    }),
                    setState: (state) => setState(state),
                    varNames
                  })
                }}
                placeholder='Add a year...'
                value={year}
              />
            )
          }
        }

        return ''
      })()}
    </div>
  )
}

export default ServiceSearch
